import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.ZONE_DISCOUNT_EDIT_SUCCESS, data: data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.ZONE_DISCOUNT_EDIT_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const zoneDiscountEdit = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.ZONE_DISCOUNT_EDIT_REQUEST });

    axios
      .put(`/polygon-discount/${id}`, data)
      .then((response) => {
        handleResponse(dispatch, response);
      })
      .catch((response) => {
        onFailed(dispatch, response.response.data);
      });
  };
};
